const linkResolver = (doc) => {
  if (['react', 'web'].includes(doc.type)) {
    return `/${doc.type}/components/${doc.tags[0]}/${doc.uid}/`;
  }
  if (['react_categories', 'web_categories'].includes(doc.type)) {
    return `/${doc.type}/components/${doc.uid}/`;
  }

  if (doc.tags) {
    const pgSlug = doc.uid.replace(/-(styling|react|web)/, '');
    if (doc.tags[1]) {
      return `/${doc.tags[0]}/${doc.tags[1]}/${pgSlug}/`;
    } else if (doc.tags[0]) {
      return `/${doc.tags[0]}/${pgSlug}/`;
    } else {
      return `/${pgSlug}/`;
    }
  }

  if (doc.type && doc.uid !== 'home') {
    return `/${doc.uid}/`;
  }

  return '/';
};

export default linkResolver;
